// extracted by mini-css-extract-plugin
module.exports = {"record":"record_record_3gCb4","userInfo":"record_userInfo_17gz_","tr":"record_tr_Q9tCU","time":"record_time_3rEdH","content":"record_content_1ybfE","orange":"record_orange_oI4Uu"};